import server from '@/request';

// 手机号密码-验证码登陆
function phoneLogin (params) {
  return server.post('/xiaozi-seller/wireless/user/phoneLogin', params);
}

function sendCaptcha (params) {
  return server.post('/xiaozi-seller/wireless/user/sendCaptcha', params);
}
function activateSendCaptcha (params) {
  return server.post('/xiaozi-seller/wireless/user/activatePlatformSendVerificationCode', params);
}

function activatePlatform (params) {
  return server.post('/xiaozi-seller/wireless/user/activatePlatform', params);
}

function getXzptEmployeeDetail (params) {
  return server.post('/xiaozi-seller/wireless/user/getXzptEmployeeDetail', params);
}

export {phoneLogin, sendCaptcha, activateSendCaptcha, activatePlatform, getXzptEmployeeDetail};
